import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { NgxTrimDirectiveModule } from 'ngx-trim-directive';
import { TranslateModule } from '@ngx-translate/core';
import { UIRouterModule } from '@uirouter/angular';

import { ButtonsAngularModule } from 'rev-shared/ui/buttons/ButtonsAngular.Module';
import { DateAngularModule } from 'rev-shared/date/DateAngular.Module';
import { DialogAngularModule } from 'rev-shared/ui/dialog/DialogAngular.Module';
import { DirectivesAngularModule } from 'rev-shared/util/directives/DirectivesAngular.Module';
import { FormDirectivesAngularModule } from 'rev-shared/util/directives/form/FormDirectivesAngular.Module';
import { SecurityAngularModule } from 'rev-shared/security/SecurityAngular.Module';
import { SpinnerAngularModule } from 'rev-shared/ui/spinner/SpinnerAngular.Module';
import { VbAuthLayoutModule } from 'rev-shared/ui/authLayout/VbAuthLayout.Module';

import { BrandingAngularModule } from 'rev-portal/branding/BrandingAngular.Module';

import { InitiateResetPasswordComponent } from './InitiateResetPassword.Component';
import { LoginComponent } from './Login.Component';
import { PasswordResetComponent } from './PasswordReset.Component';
import { Portal404Component } from './Portal404.Component';
import { SSOLogoutComponent } from './SSOLogout.Component';
import { SsoErrorDisplayComponent } from './SsoErrorDisplay.Component';
import { Unauthorized401Component } from './Unauthorized401.Component';
import { UserAgreementComponent } from './UserAgreement.Component';
import { UserConfirmationComponent } from './UserConfirmation.Component';

const components = [
	InitiateResetPasswordComponent,
	LoginComponent,
	PasswordResetComponent,
	Portal404Component,
	SSOLogoutComponent,
	SsoErrorDisplayComponent,
	Unauthorized401Component,
	UserAgreementComponent,
	UserConfirmationComponent
];

@NgModule({
	declarations: components,
	exports: components,
	imports: [
		BrandingAngularModule,
		ButtonsAngularModule,
		CommonModule,
		DateAngularModule,
		DialogAngularModule,
		DirectivesAngularModule,
		FormDirectivesAngularModule,
		FormsModule,
		NgxTrimDirectiveModule,
		SecurityAngularModule,
		SpinnerAngularModule,
		TranslateModule,
		UIRouterModule,
		VbAuthLayoutModule
	]
})
export class SecurityComponentsModule {}
